/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Last_YearInputs */

const en_date_last_year = /** @type {(inputs: Date_Last_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Year`)
};

/**
* | output |
* | --- |
* | "Last Year" |
*
* @param {Date_Last_YearInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const date_last_year = /** @type {((inputs?: Date_Last_YearInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Last_YearInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_date_last_year(inputs)
});